const markers =
[
	{
		"id": "brad-home",
		"coordinates": [-73.95412944473563, 40.737272219446595],
		"imgSrc" : require('./assets/img/lounging.png'),
		"imgName": "bradHome",
		"iconRotate": 0,
		"iconSize": 0.25,
		"mobileIconSize": 0.25,
		"iconOpacity": 1,
		"socialUrl": "https://twitter.com/BradleyFrancis_",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "brad-work",
		"coordinates": [-74.00597449840228, 40.70461457345357],
		"imgSrc" : require('./assets/img/work.png'),
		"imgName": "bradWork",
		"iconRotate": 0,
		"iconSize": 0.25,
		"mobileIconSize": 0.25,
		"iconOpacity": 1,
		"socialUrl": "https://www.linkedin.com/in/bradley-mcgovern-a4681125/",
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "brad-vero",
		"coordinates": [-80.34749022929454 , 27.624703066750996],
		"imgSrc" : require('./assets/img/beach.png'),
		"imgName": "bradVero",
		"iconRotate": 0,
		"iconSize": 0.25,
		"mobileIconSize": 0.25,
		"iconOpacity": 1,
		"socialUrl": "https://streamable.com/e004h",
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "brad-kentucky",
		"coordinates": [-84.50409204197953 , 38.03915536702047],
		"imgSrc" : require('./assets/img/beer.png'),
		"imgName": "bradKentucky",
		"iconRotate": 0,
		"iconSize": 0.15,
		"mobileIconSize": 0.15,
		"iconOpacity": 1,
		"zoom": [6],
		"socialUrl": "https://www.instagram.com/bfmcgo2/",
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "droga5-bg",
		"coordinates": [-74.00614007096057 , 40.70489746069413],
		"imgSrc" : require('./assets/img/droga5-white.png'),
		"imgName": "droga5",
		"iconRotate": -49,
		"iconSize": 1.5,
		"mobileIconSize": 1.5,
		"iconOpacity": 1,
		"locationLabel": true,
		"zoom" : [18],
		"locationTitle": "",
		"socialUrl": "https://www.instagram.com/explore/locations/298756366/droga5/",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "kentucky-logo",
		"coordinates": [-84.50554491785186 , 38.026041752973185],
		"imgSrc" : require('./assets/img/kentucky2.png'),
		"imgName": "droga5",
		"iconRotate": 0,
		"iconSize": 0.13,
		"mobileIconSize": 0.13,
		"locationLabel": true,
		"iconOpacity": 1,
		"zoom": [12],
		"mobileZoom": [12],
		"locationTitle": "",
		"socialUrl":"https://www.instagram.com/explore/locations/213737144/university-of-kentucky/",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "vero-logo",
		"coordinates": [-80.35177116788057 , 27.626242875626787],
		"imgSrc" : require('./assets/img/vero-beach-dodgers.png'),
		"imgName": "vero-beach-dodgers",
		"iconRotate": -15,
		"iconSize": 0.3,
		"mobileIconSize": 0.3,
		"locationLabel": true,
		"iconOpacity": 1,
		"zoom": [15],
		"mobileZoom": [15],
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "brad-atlanta",
		"coordinates": [-84.36207349031999 , 33.813638351487285],
		"imgSrc" : require('./assets/img/atlanta-brad.png'),
		"imgName": "bradCircus",
		"iconRotate": 0,
		"iconSize": 0.2,
		"mobileIconSize": 0.2,
		"iconOpacity": 1,
		"zoom": [6],
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "circus-logo",
		"coordinates": [-84.36181756545942 , 33.813082542573014],
		"imgSrc" : require('./assets/img/circus.png'),
		"imgName": "circusLogo",
		"iconRotate": 0,
		"iconSize": 0.1,
		"mobileIconSize": 0.1,
		"iconOpacity": 1,
		"zoom": [16],
		"mobileZoom": [16],
		"locationTitle": "",
		"socialUrl":"https://www.instagram.com/explore/locations/216841940/the-creative-circus/",
		"titleOpacity": 0,
		"iconOffset":[0,0],
	},
	{
		"id": "chase-button",
		"coordinates": [-74.0071 , 40.70424374392141],
		"mobileCoordinates":[-74.0067 , 40.70424374392141],
		"imgSrc" : require('./assets/img/chase-button2.png'),
		"imgName": "chaseButton",
		"type": "button",
		"iconRotate": 0,
		"mobileIconSize": 0.4,
		"iconSize": 0.8,
		"iconOpacity": 0,
		"zoom": [18],
		"mobileZoom": [16.5],
		"locationTitle": "",
		"titleOpacity": 0,
		"content": 
 			{
 				"client": "Chase",
 				"work": [
 					{
 						"title": "Chase Private Client",
 						"description":"Vue.js and Greensock help build this interactive tool for J.P. Morgan Chase and Co. Created the Scenario Selector page and was the only Frontend developer responsible for the implementation of the redesign. Also made the site ADA compliant.",
 						"url": "https://glimpse.chase.com/",
 						"bg_img":require('./assets/img/chasebg2.png')
 					}

 				],
 				"logo":require('./assets/img/chase.png')
 			}

	},
	{
		"id": "emoji-button",
		"coordinates": [-74.0066 , 40.70424374392141],
		"mobileCoordinates":[-74.0064 , 40.70424374392141],
		"imgSrc" : require('./assets/img/emoji-button.png'),
		"imgName": "emojiButton",
		"type": "button",
		"iconRotate": 0,
		"mobileIconSize": 0.4,
		"iconSize": 0.8,
		"iconOpacity": 0,
		"zoom": [18],
		"mobileZoom": [16.5],
		"locationTitle": "",
		"titleOpacity": 0,
		"content":
			{
				"client": "Emoji Reaction Project",
				"work" : [
					{
						"title" : "Put Your Money Where Your Emoji Is",
						"description": "Created the landing page for this in house Chrome Extension. Using Mongoose and cron jobs, I also assisted with building the charity database.",
						"url" : "https://web.archive.org/web/20181108151040/https://www.emojireactionproject.com/",
						"bg_img":require('./assets/img/emojibg.png')
					}
				],
				"logo":require('./assets/img/emoji.png')
			}

	},
	{
		"id": "hbo-button",
		"coordinates": [-74.0061 , 40.70424374392141],
		"mobileCoordinates":[-74.0061 , 40.70424374392141],
		"imgSrc" : require('./assets/img/hbo-button2.png'),
		"imgName": "hboButton",
		"type": "button",
		"iconRotate": 0,
		"mobileIconSize": 0.4,
		"iconSize": 0.8,
		"iconOpacity": 0,
		"zoom": [18],
		"mobileZoom": [16.5],
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
		"content": 
			{
 				"client": "HBO",
 				"work" : [
 					{
 						"title" : "Into HBO",
 						"description": "Using PHP, I made a script that would scrape each Instagram page within the campaign and would report back any downed pages. Completing this project propelled me from intern to full-time.",
 						"url" : "http://www.adweek.com/creativity/droga5s-first-work-hbo-byzantine-instagram-contest-hard-core-fans-171950/",
 						"bg_img":require('./assets/img/hbobg.png')
 					}
 				],
 				"logo":require('./assets/img/hbo.png')
 			}

	},
	{
		"id": "dixie-button",
		"coordinates": [-74.0056 , 40.70424374392141],
		"mobileCoordinates":[-74.0058 , 40.70424374392141],
		"imgSrc" : require('./assets/img/dixie-button3.png'),
		"imgName": "dixieButton",
		"type": "button",
		"iconRotate": 0,
		"mobileIconSize": 0.4,
		"iconSize": 0.8,
		"iconOpacity": 0,
		"zoom": [18],
		"mobileZoom": [16.5],
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
		"content": 
			{
 				"client": "Dixie",
 				"work": [
 					{
 						"title" : "Dixie.com",
 						"description": "Managed, updated, and inserted new content. Turned compiled code into components within Sitecore.",
 						"url":"https://web.archive.org/web/20180828212409/https://www.dixie.com/cupforcrushingit",
 						"bg_img":require('./assets/img/dixiebg.png')
 					}
 				],
 				"logo":require('./assets/img/dixie.png')
 			}

	},
	{
		"id": "dixietogo-button",
		"coordinates": [-74.0051 , 40.70424374392141],
		"mobileCoordinates":[-74.0055 , 40.70424374392141],
		"imgSrc" : require('./assets/img/dixie-button2.png'),
		"imgName": "dixieToGoButton",
		"type": "button",
		"iconRotate": 0,
		"mobileIconSize": 0.4,
		"iconSize": 0.8,
		"iconOpacity": 0,
		"zoom": [18],
		"mobileZoom": [16.5],
		"locationTitle": "",
		"titleOpacity": 0,
		"iconOffset":[0,0],
		"content": 
			{
 				"client": "Dixie To Go",
 				"work": [
 					{
 						"title" : "Dixie + Project Runway",
 						"description": "Dixie teamed with Project Runway to create a unique challenge during an October 5 episode. I was solely responsible for the development of this quick turnaround project.",
 						"url":"https://www.dixie.com/cupforcrushingit",
 						"bg_img":require('./assets/img/dixietogobg3.png')
 					}
 				],
 				"logo":require('./assets/img/dixietogo.png')
 			}
	}



	





	


]


export default markers;


// WEBPACK FOOTER //
// ./src/markers.js